import { PaymentDataUi } from '@/components/Buyer/BuyerProfile/PaymentAndFiscalData/PaymentData/PaymentDataUi';
import { BuyerDetailsResponse } from '@/data/api/model/buyers/BuyersDto';

export function buyerDetailsResponseToPaymentDataUi(
  input: BuyerDetailsResponse
): PaymentDataUi {
  return {
    enableAllPaymentMethods: input.is_trusted_user ?? false,
  };
}
